import cn from 'classnames'
import type {HeroV2SliceDefaultItem} from 'prismicio-types'
import type {IconTagContainerColor} from 'src/common/IconTag'
import {IconTag} from 'src/common/IconTag'

type AnimatedRatingsProps = {
  isActive: boolean
  review: HeroV2SliceDefaultItem
  version?: 'v1' | 'v2'
  iconContainerColor?: IconTagContainerColor
}

export const AnimateRatings = ({isActive, review, version = 'v1', iconContainerColor}: AnimatedRatingsProps) => (
  <div
    className={cn('absolute ease-in', {
      'animate-fadeInUp': isActive && version === 'v1',
      'animate-fadeOutUp': !isActive && version === 'v1',
      'animate-fadeInUp40': isActive && version === 'v2',
      'animate-fadeOutUp40': !isActive && version === 'v2',
      'rounded-full backdrop-blur-[5px]': version === 'v2',
    })}
    style={{
      animationDuration: '.7s',
    }}
  >
    <IconTag
      version={version}
      iconName={review.review_platform}
      label={review.label as string}
      iconContainerColor={iconContainerColor}
    />
  </div>
)
